import type { Bundle, Resource } from '@medplum/fhirtypes';

/**
 * Pick the newest history entry at or before `asOfIso` (inclusive).
 * Medplum history is typically newest-first; we sort defensively.
 */
export function pickResourceVersionAsOf<T extends Resource>(
  history: Bundle<T>,
  asOfIso: string | undefined,
): T | undefined {
  const versions = (history.entry ?? [])
    .map((entry) => entry.resource)
    .filter((resource): resource is T => Boolean(resource));
  if (versions.length === 0) return undefined;
  if (!asOfIso) return versions[0];

  const eligible = versions
    .filter((resource) => (resource.meta?.lastUpdated ?? '') <= asOfIso)
    .sort((a, b) => (b.meta?.lastUpdated ?? '').localeCompare(a.meta?.lastUpdated ?? ''));
  return eligible[0];
}
